(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["badam-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('badam-coupon')) {
    customElements.define('badam-coupon', class extends HTMLElement {
      constructor() {
        super();
        this.onCopy = this.copy.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-coupon-label]');
        this.status = this.querySelector('[role="status"]');
        this.button?.addEventListener('click', this.onCopy);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onCopy);
        clearTimeout(this.resetTimer);
      }

      fallbackCopy() {
        const previousFocus = document.activeElement;
        const input = document.createElement('textarea');
        input.value = this.dataset.code;
        input.setAttribute('readonly', '');
        input.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px;';
        document.body.append(input);
        let copied = false;
        try {
          input.focus({ preventScroll: true });
          input.select();
          input.setSelectionRange(0, input.value.length);
          copied = document.execCommand('copy');
        } catch {
          copied = false;
        } finally {
          input.remove();
          previousFocus?.focus({ preventScroll: true });
        }
        return copied;
      }

      async copy(event) {
        event.preventDefault();
        if (this.copying) return;
        this.copying = true;
        clearTimeout(this.resetTimer);
        let copied = false;
        try {
          if (navigator.clipboard?.writeText && window.isSecureContext) {
            await navigator.clipboard.writeText(this.dataset.code);
            copied = true;
          }
        } catch {
          copied = false;
        }
        if (!copied) copied = this.fallbackCopy();
        this.copying = false;
        if (!this.isConnected) return;
        this.label.textContent = copied ? this.dataset.copied : this.dataset.copy;
        this.status.textContent = copied ? this.dataset.success : this.dataset.failure;
        if (!copied) {
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('[data-coupon-code]'));
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
        this.resetTimer = setTimeout(() => {
          this.label.textContent = this.dataset.copy;
          this.status.textContent = '';
        }, 2400);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
